export var NotificationActionTypeEnum;
(function (NotificationActionTypeEnum) {
    NotificationActionTypeEnum["Redirect"] = "redirect";
    NotificationActionTypeEnum["Refresh"] = "refresh";
})(NotificationActionTypeEnum || (NotificationActionTypeEnum = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsMapper = Symbol('NotificationsMapper');
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GroupingStrategy = Symbol('GroupingStrategy');
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsEventEmitter = Symbol('NotificationsEventEmitter');
